import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';

import SearchMeta from 'app/utility/search-meta';

import { PER_PAGE_OPTIONS } from '../constants';

import './styles.scss';

class ConsultQueuePager extends Component {
  state = {
    loading: false
  };

  getReturnedLabel = () => {
    const { page, perPage, totalEntries } = this.props;
    const startPage = ((page - 1) * perPage) + Math.min(1, totalEntries);
    const endPage = Math.min(page * perPage, totalEntries);
    return `${startPage}-${endPage}`;
  };

  applyAction = (action, value) => {
    this.setState({ loading: true });
    action.call(this, value, this.props.pageParamPrefix);
  };

  render() {
    const { setPage, totalEntries, page, perPage, setPerPage, pageParamPrefix, selectedPerPage } =
      this.props;

    return (
      <div>
        <div className="consult-queue-pager">
          <SearchMeta
            totalEntries={totalEntries}
            returned={this.getReturnedLabel()}
            loading={this.state.loading}
          />
          <select
            value={selectedPerPage}
            name={`${pageParamPrefix}_per_page`}
            onChange={selected => this.applyAction(setPerPage, selected.target.value)}
          >
            {
              PER_PAGE_OPTIONS.map(filterOption => (
                <option key={filterOption.value} value={filterOption.value}>
                  {filterOption.text}
                </option>
              ))
            }
          </select>
        </div>
        <Pagination
          innerClass="rc-pager rc-pager-consult-queue"
          activePage={page}
          itemsCountPerPage={perPage}
          totalItemsCount={totalEntries}
          onChange={selectedPage => this.applyAction(setPage, selectedPage)}
          prevPageText="Previous"
          nextPageText="Next"
          hideFirstLastPages
          itemClassPrev="navigation"
          itemClassNext="navigation"
        />
      </div>
    );
  }
}


ConsultQueuePager.propTypes = {
  pageParamPrefix: PropTypes.string.isRequired,
  totalEntries:    PropTypes.number.isRequired,
  page:            PropTypes.number.isRequired,
  perPage:         PropTypes.number.isRequired,
  selectedPerPage: PropTypes.string,
  setPage:         PropTypes.func.isRequired,
  setPerPage:      PropTypes.func.isRequired
};

export default ConsultQueuePager;
